import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toHandlers as _toHandlers, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-28a938b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_2 = { class: "stat-label" }
const _hoisted_3 = ["title"]

import CountUp from '../count-up/count-up.vue'
import type { StatisticsCardItem } from './types'

export type { StatisticsCardItem } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    items: { default: () => [] },
    clickable: { type: Boolean, default: false }
  },
  emits: ["itemClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

/** 是否可交互：disabled 优先；单项 clickable 可覆盖整体 */
function isItemInteractive(item: StatisticsCardItem): boolean {
  if (item.disabled) return false
  if (item.clickable === true) return true
  if (item.clickable === false) return false
  return props.clickable
}

function onCardClick(index: number, item: StatisticsCardItem) {
  if (!isItemInteractive(item)) return
  emit('itemClick', index, item)
}

function getColSpan(span?: number): number {
  if (span) return span
  // 根据items数量自动计算，最多24列
  const count = props.items.length
  return 24 / (count || 1)
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    gutter: 16,
    class: "statistics-cards"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          key: index,
          span: getColSpan(item.span)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _mergeProps({
              class: ["stat-card el-card", { 'stat-card-clickable': isItemInteractive(item) }],
              role: isItemInteractive(item) ? 'button' : undefined,
              tabindex: isItemInteractive(item) ? 0 : undefined
            }, _toHandlers(item.events ?? {}, true), {
              onClick: ($event: any) => (onCardClick(index, item)),
              onKeydown: [
                _withKeys(_withModifiers(($event: any) => (onCardClick(index, item)), ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (onCardClick(index, item)), ["prevent"]), ["space"])
              ]
            }), [
              _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["stat-value", { 'stat-value--interactive': isItemInteractive(item) }])
              }, [
                (typeof item.value === 'number')
                  ? (_openBlock(), _createBlock(CountUp, {
                      key: 0,
                      "end-value": item.value,
                      duration: 1500
                    }, null, 8, ["end-value"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "stat-value-text",
                      title: String(item.value)
                    }, _toDisplayString(item.value), 9, _hoisted_3))
              ], 2)
            ], 16, _hoisted_1)
          ]),
          _: 2
        }, 1032, ["span"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})